export default {
  NextDayIndicator__TEXT: "Next Day",
  NextDayIndicator__TEXT_ARIA: "This flight lands the next day",
};
